export function pluralizeModelNoun(value: string): string {
  return String(value || '').trim().replace(/([a-z]+)$/i, word => {
    const irregular: Record<string, string> = {child: 'children', person: 'people', man: 'men', woman: 'women'}
    const lower = word.toLowerCase()
    let plural = irregular[lower]
    if (!plural) {
      if (['children', 'people', 'men', 'women'].includes(lower) || (/s$/i.test(word) && !/(ss|us)$/i.test(word))) return word
      plural = /[^aeiou]y$/i.test(word) ? `${word.slice(0, -1)}ies` : /(s|x|z|ch|sh)$/i.test(word) ? `${word}es` : `${word}s`
    }
    return /^[A-Z]/.test(word) ? plural.charAt(0).toUpperCase() + plural.slice(1) : plural
  })
}
